// Broker utility functions

export const getBrokerDisplayName = (broker) => {
  const displayNames = {
    tastytrade: 'Tastytrade',
    tradier: 'Tradier',
    schwab: 'Charles Schwab',
    ibkr: 'Interactive Brokers',
    interactive_brokers: 'Interactive Brokers'
  };
  
  return displayNames[broker] || broker.charAt(0).toUpperCase() + broker.slice(1).replace(/_/g, ' ');
};

export const brokerUtils = {
  getBrokerDisplayName
};

export default brokerUtils;